module.exports = __webpack_public_path__ + "media/images/vp/parallax.new.04.b-86138a325fba98a451563af3afc6f412.svg";